<template>
  <div>
    <div id="EntregaDeToken_div" class="w-100 px-5 py-4">
      <div id="TituloEntregaDeToken_div">
        <h1>ENTREGA DE TOKEN</h1>
        <h3>Control de entrega de la audiencia a personas</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudiencias"></FiltrosDeBusqueda>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Audiencias encontradas</h4>
            <h6>Seleccione la audiencia que va a entregar</h6>
            <hr />
            <div id="PanelDeAudiencias_table" class="table-responsive">
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Folio</th>
                    <th class="text-center">Fecha y Hora</th>
                    <th class="text-center">Tipo de Documento</th>
                    <th class="text-center">Consecutivo</th>
                    <th class="text-center">Partido Judicial</th>
                    <th class="text-center">Juzgado</th>
                    <th class="text-center">Materia</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="audiencias.length <= 0">
                    <td colspan="8" class="text-center">No existen registros de audiencias</td>
                  </tr>
                  <tr v-else v-for="audiencia in audiencias" :key="audiencia.AudienciaId">
                    <td class="text-center">{{audiencia.AudienciaId}}</td>
                    <td v-html="obtenFechaDeAudienciaConFormato(audiencia.FechaAudiencia)" style="width: 100px;"></td>
                    <td>{{audiencia.TipoDocumento.Nombre}}</td>
                    <td class="text-center">{{audiencia.Consecutivo}}</td>
                    <td>{{audiencia.PartidoJudicial.Nombre}}</td>
                    <td>{{audiencia.Area.Nombre}}</td>
                    <td>{{audiencia.Materia.Nombre}}</td>
                    <td class="text-center">
                      <a v-if="validaSiEsEntregableElToken(audiencia.Vigencia, (audiencia.PermisosDeLaAudiencia.length > 0 ? true : false)) == 3" v-on:click="abrirAudienciaParaVerificacionYEntregaDeToken(audiencia.AudienciaId)" title="Verificación y entrega ed token de la audiencia."><i class="fas fa-user-check"></i></a>
                      <span v-else-if="validaSiEsEntregableElToken(audiencia.Vigencia, (audiencia.PermisosDeLaAudiencia.length > 0 ? true : false)) == 1">Caducado</span>
                      <span v-else-if="validaSiEsEntregableElToken(audiencia.Vigencia, (audiencia.PermisosDeLaAudiencia.length > 0 ? true : false)) == 2">No existen personas para entregar.</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.Fecha, titulo: "Fecha de audiencia" },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo },
        ],
        audiencias: []
      }
    },
    mounted() {
      this.cargaAudiencias();
    },
    methods: {
      obtenFechaDeAudienciaConFormato: function(fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      validaSiEsEntregableElToken: function(fechaDeVigencia, existenPersonas) {
        if(moment(fechaDeVigencia).isBefore(moment()))
          return 1;

        if (!existenPersonas)
          return 2

        return 3
      },
      cargaAudiencias: function() {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          FechaInicial: this.$store.state.Comun_FechaInicial,
          PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales.filtroDeBusqueda_PartidoJudicial,
          MateriaId: this.$store.state.PJ_Catalogos_002Materias.filtroDeBusqueda_Materia,
          AreaId: this.$store.state.PJ_Catalogos_001Areas.filtroDeBusqueda_Area,
          Consecutivo: this.$store.state.Comun_Consecutivo,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.administracion.entregadetoken.GetAudiencias,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              this.audiencias = [];
            } else {
              this.audiencias = respuesta.data.Audiencias;
            }
  
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            this.audiencias = [];
          });
      },
      abrirAudienciaParaVerificacionYEntregaDeToken: function(audienciaId) {
        router.push({ name: "VerificacionYEntregaDeToken", params: { AudienciaId: audienciaId } });
      }
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }

  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Administracion/EntregaDeToken/PanelDeAudiencias.vue